export default __webpack_public_path__ + "static/dropdownBottomM-c375678be51fd53a6491e52361f58b37.png";